// Customer quotes used on more than one page. Verbatim only, from a public source
// or wording the customer approved. `ptBR` is our own translation, shown on gizmodata.com.br under the
// English quote and labelled as a translation (src/components/QuoteGloss.tsx); it never replaces the quote.

// Square headshots of the people we quote (public/customers/), shown beside their quotes.
export const quotePhotos = {
  rc: { photo: '/customers/rc-ramarathinam.webp', photoSize: 400 },
  hema: { photo: '/customers/hema-nagarajan.webp', photoSize: 307 },
  rajith: { photo: '/customers/rajith-attapattu.webp', photoSize: 400 },
};

// RC's public comment on the GizmoData Cloud launch post on LinkedIn (2026-09-30);
// the @-mention at the end is dropped. He wrote "Nexus Portal", the product's name before the
// 2026-10-07 rebrand; the new name is in [square brackets] (the standard mark for an editorial
// substitution) so the quote still matches the linked source. Summation runs it in its own
// cloud account, hence "at Customer".
export const summationNexusQuote = {
  quote: 'We love [GizmoData Cloud at Customer] at Summation. Excited to see this as a publicly available service.',
  ptBR: 'Adoramos o [GizmoData Cloud at Customer] na Summation. É empolgante vê-lo como um serviço disponível ao público.',
  author: 'Ramachandran ("RC") Ramarathinam',
  title: 'Co-Founder & CTO',
  company: 'Summation',
  linkedIn: 'https://www.linkedin.com/in/rcdexta/',
  ...quotePhotos.rc,
  source: {
    url: 'https://www.linkedin.com/feed/update/urn:li:activity:7510404170424930307/?dashCommentUrn=urn%3Ali%3Afsd_comment%3A%287511229236150640640%2Curn%3Ali%3Aactivity%3A7510404170424930307%29',
    label: 'On the GizmoData Cloud launch, via LinkedIn',
  },
};

// Chris Chilton's approved quote for the Vaden Automotive case study (2026-10-02), verbatim.
export const vadenChiltonQuote = {
  quote:
    'At Vaden Automotive Group, GizmoData in our Cloud has changed how quickly we get from a question to an answer. Its MCP server connects our data directly to AI, so our team can ask questions in natural language and get real analysis through simple prompts, then turn those results into artifacts and working applications in a fraction of the time it used to take. That makes prototyping effortless and gives us rapid insights without long development cycles. It’s fast, lightweight, and delivers true business intelligence across our entire dealership group without the large price tag. GizmoSQL has become a core part of how we see and run our business.',
  ptBR:
    'No Vaden Automotive Group, a GizmoData na nossa nuvem mudou a rapidez com que passamos de uma pergunta a uma resposta. O servidor MCP dela conecta nossos dados diretamente à IA, então nossa equipe pode fazer perguntas em linguagem natural e obter análises reais com prompts simples, e depois transformar esses resultados em artefatos e aplicações funcionais em uma fração do tempo que isso levava. Isso torna a prototipagem descomplicada e nos dá insights rápidos sem longos ciclos de desenvolvimento. É rápido, leve e entrega inteligência de negócios de verdade em todo o nosso grupo de concessionárias, sem o preço alto. O GizmoSQL se tornou parte central de como enxergamos e conduzimos o nosso negócio.',
  author: 'Chris Chilton',
  title: 'CIO',
  company: 'Vaden Automotive Group',
  linkedIn: 'https://www.linkedin.com/in/chchilton/',
  photo: '/customers/chris-chilton.webp',
  photoSize: 417,
};
